// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1y3CQ","bigColWidth":"Table_bigColWidth__3xohU","biggerColWidth":"Table_biggerColWidth__2g0pu","row":"Table_row__8W6nv","col":"Table_col__2L85_"};